import JsEval from "../../modules/utils/utils-js/theme/js/JsEval";

declare var google;

import Form from "../../modules/core/forms/theme/js/Form";
import Cart from "./Cart";
import './utils/spinner';
import PrivatePolicy from "./utils/PrivatePolicy";

// import SVGInject from "../../modules/media/svg/theme/js/SVGInject";
// import Utils from "../../modules/utils/utils-js/theme/js/utils/Utils";
// import Uploader from "../../modules/utils/uploader/theme/js/Uploader";
// import './modernizr-custom.js';

export default class Site {
    public static Cart = Cart;

    public static dispatchUpdateCartStart(): void {
        $('body').trigger('cartUpdateInit');
    }

    public static dispatchUpdateCart(): void {
        $('body').trigger('cartUpdate');
    }

    public static onContact(): void {
        const $map = $('#googleMap');
        const lat = parseFloat($map.data('lat'));
        const lng = parseFloat($map.data('lng'));


        const map = new google.maps.Map($map[0], {
            center: {
                lat: lat,
                lng: lng
            },
            zoom: 15,
            scrollwheel: false
        });
        const marker = new google.maps.Marker({
            position: {
                lat: lat,
                lng: lng
            },
            map: map,
            title: 'Obiady Abonamentowe'
        });
    }

    private static initHtml() {
        (<any> $('#dfoodyMenu')).smartmenus({
            subMenusSubOffsetX: 6,
            subMenusSubOffsetY: -8
        });

        $('.smoothscroll').on('click', function(e) {
            e.preventDefault();
            var target = (<any> this).hash;

            $('html, body').stop().animate({
                'scrollTop': $(target).offset().top - 80
            }, 1200);
        });

        $('.searchIcon').on('click', function() {
            $('.hSearchBox').removeClass('hide');
            $('.hSearchBox').toggleClass('active');
        });

        const $cartbox = $('.header__cartbox');

        const updateEls = () => {
            const $items = $('.shopping-cart-items > li');

            $items.each((ix, el) => {
                const $item = $(el);
                const id = $item.data('id');

                $('.cartProduct-remove', $item).on('click', (e) => {
                    Cart.removeItem(id, true, () => {
                        updateEls();
                    });
                });
            });
        }

        $('.js-add-cart-btn').each((ix, el) => {
            const $el = $(el);

            $el.on('click', (e) => {
                e.preventDefault();

                $.post('/cartapi/add', {
                    id: $el.data('id'),
                }, (r) => {
                    $el.addClass('flash');

                    $cartbox.html(r.carthtml);
                    updateEls();

                    $('#cart .badge').addClass('flash');

                    window.location.pathname = $el.attr('href');
                });
            });
        });

        updateEls();
    }

    /**
     * @override
     */
    public static init(): void {
        (<any> window).Site = Site;

        Form.init();

        $(window).on('load', () => {
            Site.initHtml();
            PrivatePolicy.initCookieConsent();
        });

        // $(window).on('load', () => {
        //     $('body').addClass('body--loaded');

        //     setTimeout(() => {
        //         $('body').removeClass('body--loading');
        //         $('body').addClass('body--loaded2');
        //         $('body').trigger('pageloaded');
        //     }, 1000);
        // });

        JsEval.eval();
    }
}

Site.init();
